var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteEventListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3608 0.832H9.60867V0.66C9.60867 0.1 9.12377 0 8.53182 0H5.44928C4.85734 0 4.37664 0.1 4.37664 0.66V0.832H0.639179C0.555202 0.831868 0.472024 0.847531 0.394413 0.878089C0.316802 0.908648 0.246284 0.953501 0.186904 1.01008C0.127523 1.06666 0.0804466 1.13384 0.0483739 1.20779C0.0163011 1.28174 -0.000137369 1.36099 8.64622e-07 1.441V2.617C8.64622e-07 2.77852 0.0673426 2.93342 0.187212 3.04763C0.307081 3.16184 0.469659 3.226 0.639179 3.226H13.3608C13.5303 3.226 13.6929 3.16184 13.8128 3.04763C13.9327 2.93342 14 2.77852 14 2.617V1.441C14 1.27948 13.9327 1.12458 13.8128 1.01037C13.6929 0.896162 13.5303 0.832 13.3608 0.832Z",
    fill: "#DC5D5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0195 4.84399H1.98054C1.8903 4.84475 1.80124 4.86368 1.71921 4.89953C1.63718 4.93539 1.56404 4.98736 1.50457 5.05205C1.44511 5.11673 1.40067 5.19266 1.37417 5.27486C1.34767 5.35705 1.33971 5.44366 1.35081 5.52899L2.38042 12.951C2.41882 13.2395 2.56589 13.5049 2.79427 13.6979C3.02265 13.8908 3.31681 13.9982 3.62204 14H10.378C10.6842 13.9994 10.9796 13.8926 11.2091 13.6995C11.4385 13.5065 11.5864 13.2404 11.6249 12.951L12.6535 5.52899C12.6648 5.4433 12.6568 5.35629 12.6301 5.27374C12.6035 5.1912 12.5586 5.115 12.4987 5.05022C12.4387 4.98544 12.365 4.93354 12.2824 4.89799C12.1998 4.86243 12.1102 4.84403 12.0195 4.84399Z",
    fill: "#DC5D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEventListIcon);
export default __webpack_public_path__ + "static/media/deleteEventListIcon.3da7021c49db870e913b29187a8b9f5f.svg";
export { ForwardRef as ReactComponent };